module.exports = __webpack_public_path__ + "img/brief_picture_ruanshili.993fd0e7.png";